// extracted by mini-css-extract-plugin
export default {"btn":"GenMsgBox_btn__D+hiV","modal":"GenMsgBox_modal__Fd2k3","backdrop":"GenMsgBox_backdrop__+vEdq"};